<!--
	日期：2025/09/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：我的个人信息修改
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-readsignagree" class="app-readsignagree">
	<myLegalNotice :mln_id="'forsignagree'" :mini-show="true"></myLegalNotice>
	</div>
</template>

<script>
import myLegalNotice from '../components/LegalNotice.vue'
import { getQuery, getDownloadURL } from '../api/'
export default {
	name: 'app-readsignagree',
	components: {
		myLegalNotice,
	},
	data() { return {
	}},
	state: {
	},
	mounted() {
	},
	methods: {
	},
	computed: {
	},
	mutations: {
	}
}
</script>

<style lang="less" Scoped>
.app-readsignagree {
  padding: 5px;

}
</style>